import styled from 'styled-components';

const fullGridBorderRadiusPixels = '10px';

export const GridWrapper = styled.div`
  height: 100%;
  width: 100%;
  font-family: 'Nunito Sans', sans-serif !important;
  border-radius: ${fullGridBorderRadiusPixels};
  border: 1px dashed #bdc3c7 !important;

  /*
    Hides solid border on top of cells. Instead, dashed borders are visible.
    The dashed borders are determined here: .ag-header-row:nth-child(2)
    This change was added as a result of changes made in v24.0.0.
    TODO: Make css smaller by resolving conflict between this css rule and
    the one mentioned three lines above.
  */
  .ag-header-cell {
    border-top: none !important;
  }

  /*
    Hides border around table. This border was added in v24
    TODO: Use this as the actual dashed border. Delete order border
  */
  .ag-root-wrapper.ag-layout-normal.ag-ltr {
    border-radius: ${fullGridBorderRadiusPixels};
    border: none;
  }

  .ag-row {
    color: rgba(0, 0, 0, 0.85);
    cursor: pointer;
  }

  .ag-row.ag-row-odd::not(.ag-row-selected) {
    /* use zebra pattern only when row not selected */
    background-color: #fbfcff;
  }

  .ag-cell-focus,
  .ag-cell-no-focus {
    border: none !important;
  }

  /* Centers content of row group cells. A bit high otherwise */
  &.ag-theme-balham .ag-cell-wrapper.ag-row-group {
    display: flex;
    align-items: center;
  }

  &.ag-theme-balham .ag-row {
    font-size: 14px;
    border-top: 0;
    border-top-style: none;
    border-bottom: 1px dashed #bdc3c7;

    .ag-row-last {
      border-bottom: unset;
    }

    .ag-cell-last-left-pinned {
      /* adds vertical line where pinned columns end */
      border-right: 1px dashed #bdc3c7 !important;
    }

    /* Centers content on cells. A bit high otherwise */
    .ag-cell {
      display: flex;
      align-items: center;
      border: none; /* else cells will have 1px border by default */
    }
  }

  &.ag-theme-balham .ag-status-bar {
    border: none !important;
  }

  &.ag-theme-balham .ag-header {
    border-bottom: none;
    font-family: 'Nunito Sans', sans-serif;

    .ag-header-row {
      background-color: #f0f5ff !important;
    }

    /* Draws border between the header-group row and column headers row */
    .ag-header-row:nth-child(2) {
      border-top: 1px dashed #bdc3c7 !important;
      border-bottom: 1px dashed #bdc3c7 !important;
    }

    .ag-header-cell-text,
    .ag-header-group-text {
      font-size: 12px;
      font-weight: 600;
      white-space: normal;
    }
  }

  .ag-row-group {
    cursor: auto;
  }

  &.ag-theme-balham .ag-row-hover {
    background-color: rgba(33, 150, 243, 0.1);

    .address-cell {
      /* TODO: check if still needed */
      color: #37a3bc;
    }
  }

  /* outermost wrapper border becomes dashed */
  &.ag-theme-balham .ag-root {
    border: none;
    border-radius: ${fullGridBorderRadiusPixels};
    border-border-top-right-radius: 'inherit';
  }

  /* Removes border drawn in between the header-group row, and column header row
     We are placing a dashed border in between those rows, and this style rule
     prevents writing two borders. Cannot override border here as this border affects
     more than one place */
  &.ag-theme-balham .ag-header-cell:not(.ag-header-group-cell-no-group),
  &.ag-theme-balham .ag-header-group-cell:not(.ag-header-group-cell-no-group) {
    border-top-width: 0px;
  }
`;
